webpackJsonp([2],{

/***/ 48:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(6);
function NotFound(){var _useHistory=Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* useHistory */])(),push=_useHistory.push;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"notfound flex flex-col mx-auto w-full h-screen bg-dark text-white place-content-center place-items-center "},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",null,"404 - Not Found!"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{onClick:function onClick(){return push("/");}},"Back"));}/* harmony default export */ __webpack_exports__["default"] = (NotFound);

/***/ })

});


// WEBPACK FOOTER //
// static/js/2.160eaf12.chunk.js